import Box from "@material-ui/core/esm/Box";
import Chip from "@material-ui/core/esm/Chip";
import FormControl from "@material-ui/core/esm/FormControl";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import Grid from "@material-ui/core/esm/Grid";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import FiberManualRecord from "@material-ui/icons/esm/FiberManualRecord";
import Star from "@material-ui/icons/esm/Star";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import { BoldSubtitle } from 'components/Text';
import { SubscriptionPlan } from 'utils/mapping/mapSubscriptionPlan';
import isNorwegian from 'utils/language/isNorwegian';
import useStyles from './ChooseSubscriptionPlanStyles';
export default function ChooseSubscriptionPlan({
  selectedPlan,
  onPlanSelect
}) {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    planOption,
    selectedPlanOption,
    planHeader,
    standardPlanHeader,
    basicPlanHeader,
    radio,
    checked,
    planPrice,
    featuresList,
    featureItem,
    recommendedBadge,
    planContent,
    plansContainer,
    standardPlanOption,
    basicPlanOption,
    standardPlanContainer,
    termsSection,
    textContent
  } = useStyles();
  const standardFeatures = ['subscriptions.features.autopass_discount', 'subscriptions.features.ferry_discount', 'subscriptions.features.email_notifications', 'subscriptions.features.full_app_access', 'subscriptions.features.exclusive_benefits', 'subscriptions.features.free_tag_replacement', 'subscriptions.features.no_setup_fee'];
  const basicFeatures = ['subscriptions.features.autopass_discount', 'subscriptions.features.ferry_discount', 'subscriptions.features.email_notifications'];
  const plans = [{
    key: SubscriptionPlan.Standard,
    type: 'standard',
    features: standardFeatures
  }, {
    key: SubscriptionPlan.Basic,
    type: 'basic',
    features: basicFeatures
  }];
  const orderedPlans = isNorwegian(i18n) ? plans : [...plans].reverse();
  return /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('register_vehicle.choose_subscription_plan')), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    name: "subscriptionPlan",
    value: selectedPlan,
    onChange: e => onPlanSelect(e.target.value)
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    className: plansContainer
  }, orderedPlans.map(plan => {
    const isStandard = plan.type === 'standard';
    const isSelected = selectedPlan === plan.key;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: plan.key
    }, /*#__PURE__*/React.createElement(Box, {
      className: isStandard ? standardPlanContainer : ''
    }, /*#__PURE__*/React.createElement(Box, {
      className: `
                            ${planOption} 
                            ${isStandard ? standardPlanOption : basicPlanOption}
                            ${isSelected ? selectedPlanOption : ''}
                        `,
      onClick: () => onPlanSelect(plan.key)
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: plan.key,
      control: /*#__PURE__*/React.createElement(Radio, {
        classes: {
          root: radio,
          checked
        },
        onClick: e => e.stopPropagation()
      }),
      label: ""
    }), /*#__PURE__*/React.createElement(Box, {
      flex: 1,
      ml: 1,
      className: planContent
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1
    }, /*#__PURE__*/React.createElement("div", {
      className: `${planHeader} ${isStandard ? standardPlanHeader : basicPlanHeader}`
    }, isStandard && /*#__PURE__*/React.createElement(Star, {
      fontSize: "small"
    }), t(`subscriptions.plans.${plan.type}`)), isStandard && isNorwegian(i18n) && /*#__PURE__*/React.createElement(Chip, {
      label: t('subscriptions.recommended'),
      size: "small",
      className: recommendedBadge
    })), /*#__PURE__*/React.createElement("div", {
      className: planPrice
    }, t(`subscriptions.pricing.${plan.type}`)), /*#__PURE__*/React.createElement("ul", {
      className: featuresList
    }, plan.features.map((featureKey, index) => /*#__PURE__*/React.createElement("li", {
      key: index,
      className: featureItem
    }, /*#__PURE__*/React.createElement(FiberManualRecord, {
      fontSize: "small"
    }), /*#__PURE__*/React.createElement("div", {
      className: textContent
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: featureKey,
      components: {
        bold: /*#__PURE__*/React.createElement("strong", null)
      }
    })))))))));
  })))), /*#__PURE__*/React.createElement(Box, {
    className: termsSection
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    link: t('register_vehicle.terms_and_conditions_link')
  }, t('register_vehicle.terms_and_conditions'))));
}